import { useDialogStore, type AppDialogVariant } from '../store/dialogStore';

export function appConfirm(
  message: string,
  options?: {
    title?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    variant?: AppDialogVariant;
    icon?: string;
  },
): Promise<boolean> {
  return useDialogStore.getState().open({
    variant: options?.variant ?? 'confirm',
    title: options?.title ?? 'Confirm',
    message,
    confirmLabel: options?.confirmLabel ?? 'OK',
    cancelLabel: options?.cancelLabel ?? 'Cancel',
    icon: options?.icon,
    showCancel: true,
  });
}

export function appAlert(
  message: string,
  options?: {
    title?: string;
    okLabel?: string;
    variant?: Exclude<AppDialogVariant, 'confirm'>;
    icon?: string;
  },
): Promise<void> {
  return useDialogStore
    .getState()
    .open({
      variant: options?.variant ?? 'alert',
      title: options?.title ?? 'Notice',
      message,
      confirmLabel: options?.okLabel ?? 'OK',
      icon: options?.icon,
      showCancel: false,
    })
    .then(() => undefined);
}

export function dialogVariantTone(variant: AppDialogVariant): string {
  switch (variant) {
    case 'danger':
      return 'app-dialog__confirm--danger';
    case 'warning':
      return 'app-dialog__confirm--warning';
    case 'success':
      return 'app-dialog__confirm--success';
    case 'alert':
    case 'confirm':
    default:
      return 'app-dialog__confirm--primary';
  }
}

export function dialogVariantIcon(variant: AppDialogVariant, icon?: string): string {
  if (icon) return icon;
  switch (variant) {
    case 'danger':
      return 'error';
    case 'warning':
      return 'warning';
    case 'success':
      return 'check_circle';
    case 'alert':
      return 'info';
    case 'confirm':
    default:
      return 'help';
  }
}
